import { Fee } from 'generated/graphql';

export type BestItineraryData = {
  highlightedType: string | null;
  itinerary?: Fee;
  position?: number;
};
export const createBestItineraryData = (
  highlightedType: string | null,
  itinerary: Fee,
  position: number
) => ({
  highlightedType,
  ...(position !== undefined && { itinerary, position }),
});
